<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{ '--width': widthVar }" class="pageHeader">随手拍</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <el-form-item label="审批状态">
          <el-select v-model="formInline.status" clearable filterable placeholder="请选择">
            <el-option v-for="item in $store.state.reviewStatus" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="检查对象">
          <el-select v-model="formInline.target_id" clearable filterable :placeholder="`请选择`">
            <el-option v-for="item in $store.state.trainRooms" :key="item.id" :label="item.training_name"
              :value="item.id"></el-option>
          </el-select>
        </el-form-item> -->

        <el-form-item label="检查对象">
          <el-input v-model="formInline.checker_name" clearable placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="隐患等级">
          <el-select v-model="formInline.hazard_level" clearable filterable placeholder="请选择">
            <el-option v-for="item in $store.state.yhlevel" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="检查时间">
          <el-date-picker type="datetime" placeholder="请选择" value-format="yyyy-MM-dd HH:mm:ss" clearable
            v-model="formInline.check_date"></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleAdd(() => {
            $nextTick(() => {
              $refs.uploadd.setRefFileList('');
            });
          })">随手拍</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div>
      <custom-table :data="tableData" border style="width: 100%">
        <custom-table-column fixed label="序号" type="index" width="50">
        </custom-table-column>
        <custom-table-column prop="target_name" fixed label="检查对象" min-width="160px">
        </custom-table-column>
        <custom-table-column prop="check_date" label="检查时间" width="160px">
        </custom-table-column>
        <custom-table-column prop="review_status_text" label="审批状态" width="100px">
        </custom-table-column>
        <custom-table-column prop="reject_reason" label="审批意见" width="160px">
        </custom-table-column>
        <custom-table-column prop="hazard_level_text" label="隐患等级" width="100px">
        </custom-table-column>
        <custom-table-column prop="deadline" label="整改期限" width="180px">
        </custom-table-column>
        <custom-table-column prop="description" label="隐患描述" min-width="220px">
        </custom-table-column>
        <custom-table-column label="隐患图片" min-width="240px">
          <template slot-scope="scope" v-if="scope.row.images">
            <el-image v-for="(img, index) in scope.row.images" :key="index" style="width: 50px; height: 50px" :src="img"
              :preview-src-list="scope.row.images">
            </el-image>
          </template>
        </custom-table-column>
        <!-- <custom-table-column fixed="right" label="操作" width="120">
          <template slot-scope="scope">
            <template v-if="scope.row.status == 0">
              <el-button @click="handleEditNew(scope.row)" type="text" size="small">编辑</el-button>
              <el-button @click="handleDelet(scope.row.id)" type="text" size="small">删除</el-button>
            </template>
          </template>
        </custom-table-column> -->
      </custom-table>
      <div class="pageLine">
        <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="centerDialogVisible" width="706px">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="检查时间" prop="check_date">
          <el-date-picker type="datetime" placeholder="请选择" value-format="yyyy-MM-dd HH:mm:ss"
            v-model="ruleForm.check_date" style="width: 216px;"></el-date-picker>
        </el-form-item>
        <el-form-item label="检查对象" prop="target_id">
          <el-select v-model="ruleForm.target_id" clearable filterable :placeholder="`请选择`" style="width: 216px;">
            <el-option v-for="item in $store.state.trainRooms" :key="item.id" :label="item.training_name"
              :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="隐患等级" prop="hazard_level">
          <el-radio-group v-model="ruleForm.hazard_level" style="width:216px;">
            <el-radio v-for="item in $store.state.yhlevel" :key="item.value" :label="item.value">{{ item.label
            }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="整改期限" prop="deadline">
          <el-date-picker type="datetime" placeholder="请选择" value-format="yyyy-MM-dd HH:mm:ss"
            v-model="ruleForm.deadline" style="width: 216px;" :picker-options="pickerOptions"></el-date-picker>
        </el-form-item>
        <el-form-item label="隐患描述" prop="description">
          <el-input type="textarea" v-model="ruleForm.description" :rows="5" placeholder="请输入"
            style="width:532px;"></el-input>
        </el-form-item>
        <el-form-item label="隐患图片" prop="images" style="width:100%">
          <Uploadd ref="uploadd" fileFieldNameIn="images" :isMultiple="true" btnTitle="点击上传图片"
            @setFileList="setFileListMultiple" uploadType="image" @delFile="delUpFile"></Uploadd>
        </el-form-item>
        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button type="primary" v-if="type == 'add'"
            @click="submitFormByFun('ruleForm', createMethod)">确认</el-button>
          <!-- <el-button type="primary" v-if="type == 'edit'"
            @click="submitFormByFun('ruleForm', updateMethod)">编辑</el-button> -->
          <el-button @click="resetForm('ruleForm')" style="margin-right:24px;">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- <el-dialog :close-on-click-modal="false" title="提示" :visible.sync="dialogVisible" width="400px">
      <span>是否删除</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteMethod">确 定</el-button>
      </span>
    </el-dialog> -->
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import { mixinValidate } from '@/assets/js/mixin/validate';
import { mixinFormatter } from '@/assets/js/mixin/formatter';
import { mixinUpload } from '@/assets/js/mixin/upload';

export default {
  name: 'equipmentInto',
  mixins: [mixinList, mixinValidate, mixinFormatter, mixinUpload],
  data() {
    return {
      formInline: {
        status: '',
        checker_name: '',
        hazard_level: '',
        check_date: '',
      },
      rowObj: {},
      users: [],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < (Date.now() - 24 * 60 * 60 * 1000);
        },
      },
      detailDialogVisible: false,
      ruleForm: {
        hazard_level: '',
        check_date: '',
        target_id: '',
        description: '',
        images: '',
        deadline: '',
      },
      loading: false,
      rules: {
        target_id: [{ required: true, message: '请选择', trigger: 'change' }],
        check_date: [{ required: true, message: '请选择', trigger: 'change' }],
        hazard_level: [{ required: true, message: '请选择', trigger: 'change' }],
        deadline: [{ required: true, message: '请选择', trigger: 'change' }],
        images: [{ required: true, message: '请上传' }],
        description: [{ required: true, message: '请输入', trigger: 'blur' }],
        content: [{ required: true, message: '请输入', trigger: 'blur' }],
      },
    };
  },
  created() {
    this.$store.dispatch('getTarinMent');
    // 
  },
  mounted() {
  },
  methods: {
    // async deleteMethod() {
    //   let res = await this.$api.instance.interfaceServer(`api/safe-check-activity/delete/${this.delid}`, 'delete');
    //   if (res.code == 0) {
    //     this.$message({
    //       type: 'success',
    //       center: true,
    //       message: '删除成功！',
    //     });
    //     this.dialogVisible = false;
    //     this.handleQuery();
    //   }
    // },

    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let res = await this.$api.instance.interfaceServer('api/quick-photo/list', 'get', params);
      if (res.code == 0 && res.data) {
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },
    async createMethod() {
      let params = this.$until.deleteNullPrototype(this.ruleForm);
      let res = await this.$api.instance.interfaceServer('api/quick-photo/upload', 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '提交成功！',
        });
        this.clearState();
      }
    },
    handleQuery() {
      this.$refs.pageChild.page = 1;
      this.getList();
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}
</style>
